const _login_user = ShopifyAnalytics.meta.page.customerId;
if (!_login_user) {
  window.location.href = "/account/login";
} else {
  //show page and list my favorites product list
  console.log("My favorites -----");
  const url = "https://easterncurator-app.vercel.app/api/favorites?customer_id=" + _login_user.toString();
  fetch(url)
    .then((response) => response.json())
    .then(async (response) => {
      console.log(response.list);
      await set_my_favorites(response.list);
      addRemoveBtnClickFunction();
    });
}

const addRemoveBtnClickFunction = () => {
  const _btn_remove_my_favorites = document.querySelectorAll(".btn_remove");
  _btn_remove_my_favorites.forEach(function (currentBtn) {
    currentBtn.addEventListener("click", (handleEvent) => {
      const _prod_handle = currentBtn.getAttribute("data-url");
      console.log(_prod_handle);
      update_favorites(_prod_handle);
      remove_div(_prod_handle);
    });
  });
}

const update_favorites = async (prod_handle) => {
  const payload = {};
  payload.customer_id = _login_user.toString();
  payload.prod_handle = prod_handle;
  const url = "https://easterncurator-app.vercel.app/api/favorites";
  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => response.json())
    .then(async (response) => {
      console.log(response);
    });
};

const remove_div = (prod_handle) => {
  const _blocks = document.querySelectorAll(".block");
  const _btn_remove_my_favorites = document.querySelectorAll(".btn_remove");
  let _index = -1;
  let _r_index = 0;
  _btn_remove_my_favorites.forEach(function (currentBtn) {
    _index++;
    const _prod_handle = currentBtn.getAttribute("data-url");
    if (prod_handle == _prod_handle) {
      _r_index = _index;
    }
  });
  _blocks[_r_index].remove();
}

const set_my_favorites = async (list) => {
  const _my_favorites = document.getElementById("my_favorites");
  let _html = "";
  if (list && list.length > 0) {
    for (const item of list) {
      const _prodInfo = await getProductByHandle(item.handle);
      if (_prodInfo) {
        const _template = createTemplate(_prodInfo, item.handle);
        _html += _template;
      }
    }
    _my_favorites.innerHTML = _html;
  } else {
    _my_favorites.innerHTML = `<div class="f-no-data">No data</div>`;
  }
}

// 获取商品信息的函数
async function getProductByHandle(handle) {
  const query = `
            query($handle: String!) {
              productByHandle(handle: $handle) {
                id
                title
                description
                vendor
                metafields(identifiers: [{namespace: "custom", key: "cus_oiloncanvas"}]) {
                  key
                  value
                }
                variants(first: 5) {
                  edges {
                    node {
                      id
                      title
                      price {
                        amount
                        currencyCode
                      }
                      product {
                        id
                        featuredImage {
                          originalSrc
                          altText
                        }
                      }
                      sku
                    }
                  }
                }
              }
            }
          `;

  const variables = {
    handle: handle,
  };

  return fetchGraphQL(query, variables)
    .then((data) => {
      const product = data.productByHandle;
      console.log(product);
      return product;
    })
    .catch((error) => {
      console.error("Error retrieving product:", error);
    });
}

function fetchGraphQL(query, variables = {}) {
  const endpoint =
        "https://store.magnifissance.com/api/2023-04/graphql.json";
    const accessToken = "6dd485b7997c77cc4794f50f5ff2ae3b"; // 替换为您的访问令牌

  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": accessToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  })
    .then((response) => response.json())
    .then((data) => data.data)
    .catch((error) => {
      console.error("GraphQL Error:", error);
    });
}

const createTemplate = (prod, prod_handle) => {
  let _ooc = "";
  if (prod && prod.metafields && prod.metafields.length > 0) {
    for (const item of prod.metafields) {
      if (item && item.key && item.key == "cus_oiloncanvas") {
        _ooc = item.value;
      }
    }
  }
  let _html = `<div class="block">
    <div class="img">
        <img src=${prod.variants.edges[0].node.product.featuredImage.originalSrc}">
    </div>
    <div class="info">
        <div class="vendor">${prod.vendor}</div>
        <div class="title"><a href="/products/${prod_handle}">${prod.title}</a></div>
        <div class="attr">Oil on Canvas,${_ooc}</div>
    </div>
    <div class="btn_remove" data-url="${prod_handle}">
    <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-hidden="true"
    focusable="false"
    class="icon icon-remove"
  >
    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>
    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>
  </svg>
  
    </div>
    </div>
`
  return _html;
}